import {
  AddonDrawdown,
  AddonExtraAllowPayoutTime,
  AddonPerformanceAccountFee,
  AddonType,
  MarketDataTypes,
  PerformanceAccountType,
  PeriodUnit,
  ProductAccountTypes,
  ProductTradingAccountTypes,
  ProductTypes,
  ReBillTimesType,
  StartDateCalculation,
  YesOrNo,
} from '@src/types/productsAddons.ts';
import { TOption, TradingPlatForms } from '@src/types';

export const productTypeData: TOption[] = [
  { label: 'Trading Account', value: ProductTypes.TRADING_ACCOUNT },
  {
    label: 'Add ons/ Edge Enhancers',
    value: ProductTypes.ADD_ONS_EDGE_ENHANCERS,
  },
  {
    label: 'Resets',
    value: ProductTypes.RESETS,
  },
  {
    label: 'Market Data',
    value: ProductTypes.MARKET_DATA,
  },
  {
    label: 'Other',
    value: ProductTypes.OTHER,
  },
];

export const marketData: TOption[] = [
  { label: 'CME Market Depth', value: MarketDataTypes.CME_MARKET_DEPTH },
  { label: 'CBOT Market Depth', value: MarketDataTypes.CBOT_MARKET_DEPTH },
  { label: 'COMEX Market Depth', value: MarketDataTypes.COMEX_MARKET_DEPTH },
  { label: 'NYMEX Market Depth', value: MarketDataTypes.NYMEX_MARKET_DEPTH },
  {
    label: 'Market Depth | 4 Bundle',
    value: MarketDataTypes.MARKET_DEPTH_4_BUNDLE,
  },
];

export const performanceAccountTypeData: TOption[] = [
  {
    label: 'Performance Account Monthly',
    value: PerformanceAccountType.PERFORMANCE_ACCOUNT_MONTHLY,
  },
  {
    label: 'Performance Account One Time Fee',
    value: PerformanceAccountType.PERFORMANCE_ACCOUNT_ONE_TIME_FEE,
  },
];

export const productTradingAccountTypeData: TOption[] = [
  {
    label: 'Practice Account',
    value: ProductTradingAccountTypes.PRACTICE_ACCOUNT,
  },
  {
    label: 'Straight to PA',
    value: ProductTradingAccountTypes.STRAIGHT_TO_PA,
  },
  {
    label: 'Specialty Account',
    value: ProductTradingAccountTypes.SPECIALTY_ACCOUNT,
  },
];

export const productAccountTypeData: TOption[] = [
  { label: 'Foundation', value: ProductAccountTypes.FOUNDATION },
  {
    label: 'Entry',
    value: ProductAccountTypes.ENTRY,
  },
  {
    label: 'Bundle',
    value: ProductAccountTypes.BUNDLE,
  },
  {
    label: 'Weekly',
    value: ProductAccountTypes.WEEKLY,
  },
];

export const tradingPlatFormsData: TOption[] = [
  {
    label: 'Rithmic Data Feed',
    value: TradingPlatForms.RITHMIC_DATA_FEED,
  },
  // { label: 'DX Data Feed', value: TradingPlatForms.DX_DATA_FEED },
];

export const companyData: TOption[] = [
  { label: 'Rithmic', value: TradingPlatForms.RITHMIC_DATA_FEED },
  // { label: 'Dxfeed', value: TradingPlatForms.DX_DATA_FEED },
  // { label: 'Tradovate CRM', value: TradingPlatForms.CQG_DATA_FEED }, // Commented out
];

export const extraAllowedPayoutTimeData: TOption[] = [
  { label: 'All', value: AddonExtraAllowPayoutTime.ALL },
  { label: '1st', value: AddonExtraAllowPayoutTime.FIRST_TIME },
  { label: '2nd', value: AddonExtraAllowPayoutTime.SECOND_TIME },
];

export const performanceAccountFeeData: TOption[] = [
  { label: 'Monthly', value: AddonPerformanceAccountFee.MONTHLY },
  {
    label: 'Lifetime One-time payment',
    value: AddonPerformanceAccountFee.LIFETIME_ONE_TIME,
  },
  {
    label: 'Lifetime One-time payment upfront',
    value: AddonPerformanceAccountFee.LIFETIME_PAY_UPFRONT,
  },
  {
    label: 'Lifetime One-time payment partial',
    value: AddonPerformanceAccountFee.LIFETIME_PAY_PARTIAL,
  },
];

export const drawdownData: TOption[] = [
  { label: '$0 part of base price', value: AddonDrawdown.NONE },
  { label: '+$500 — $XXX', value: AddonDrawdown.PLUS_500 },
  { label: '+$1,000 — $XXX', value: AddonDrawdown.PLUS_1000 },
  { label: '+$1,500 — $XXX', value: AddonDrawdown.PLUS_1500 },
];

export const addonTypeData: TOption[] = [
  {
    label: `EVAL - Qualify in 'x' trading days`,
    value: AddonType.EvalQualifyInXTradingDays,
  },
  {
    label: `EVAL - Reduced PA Lifetime Fee`,
    value: AddonType.EvalReducedPaLifetimeFee,
  },
  {
    label: `EVAL - Discount 'x'% Reset`,
    value: AddonType.EvalDiscountXPercentReset,
  },
  {
    label: `PA - Allow extra amount on payout`,
    value: AddonType.PaAllowExtraAmountOnPayout,
  },
  {
    label: `PA - Payout every 'x' days`,
    value: AddonType.PaPayoutEveryXDays,
  },
  {
    label: `PA - Change 30% rule to 'x' %`,
    value: AddonType.PaChange30PercentRuleToXPercent,
  },
  {
    label: 'Straight to PA',
    value: AddonType.StraightToPa,
  },
  {
    label: 'Performance Account Fee',
    value: AddonType.PerformanceAccountFee,
  },
  {
    label: 'Bundle',
    value: AddonType.AccountBundle,
  },
  {
    label: 'Drawdown',
    value: AddonType.Drawdown,
  },
];

export const dateSelectData: TOption[] = [
  { label: 'Days', value: PeriodUnit.Day },
  { label: 'Months', value: PeriodUnit.Month },
  { label: 'Years', value: PeriodUnit.Year },
  { label: 'Life Times', value: PeriodUnit.LIFETIMES },
];

export const rebillTimesTypeData: TOption[] = [
  { label: 'No more charges', value: ReBillTimesType.NoMoreCharges },
  {
    label: 'Charge Second Price Once',
    value: ReBillTimesType.ChargeSecondPriceOnce,
  },
  {
    label: 'Charge Second Price x Times',
    value: ReBillTimesType.ChargeSecondPriceTimes,
  },
  {
    label: 'Rebill Second Price until cancelled',
    value: ReBillTimesType.ReBillSecondPriceUntilCancelled,
  },
];

export const isBundleData: TOption[] = [
  { label: 'Yes', value: YesOrNo.Yes },
  { label: 'No', value: YesOrNo.No },
];
export const productSurveyTriggerTimeData: TOption[] = [
  { label: 'On Account Purchase', value: 'on_account_purchase' },
  { label: 'On qualifying ', value: 'on_qualifying' },
];
export const drawdownTypeData: TOption[] = [
  { label: 'Static', value: 'static' },
  { label: 'End of Day', value: 'end_of_day' },
];
export const payoutRequestTriggerData: TOption[] = [
  { label: 'Date Eligible', value: 'date_eligible' },
  { label: 'Last Saturday', value: 'last_saturday' },
];
export const payoutDateEligibleTypeData: TOption[] = [
  {
    label: 'Eligible on the day once requirements are met',
    value: 'eligible_on_day_once_requirements_met',
  },
  {
    label: 'The nearest upcoming Saturday',
    value: 'nearest_upcoming_saturday',
  },
  {
    label: 'Last Saturday of the Month',
    value: 'last_saturday_of_month',
  },
];
export const accountMeetingPayoutRequirementsData: TOption[] = [
  { label: 'Keep open', value: 'keep_open' },
  { label: 'Close account', value: 'close_account' },
];
export const startDateCalculationOptions: TOption[] = [
  {
    value: StartDateCalculation.LAST_EXISTING_SUBSCRIPTION_DATE_OF_THIS_PRODUCT,
    label: 'Last existing subscription date of this product',
  },
  {
    value: StartDateCalculation.LAST_EXPIRATION_DATE_IN_THE_RENEWAL_GROUP,
    label: 'Last expiration date in the renewal group',
  },
  { value: StartDateCalculation.FIXED_DATE, label: 'Fixed date' },
  { value: StartDateCalculation.PAYMENT_DATE, label: 'Payment date' },
  { value: StartDateCalculation.NEXT_DAY, label: 'Next Day' },
  {
    value: StartDateCalculation.FIRST_DAY_OF_CURRENT_MONTH,
    label: '1st of current Month',
  },
  {
    value: StartDateCalculation.LAST_OF_CURRENT_MONTH,
    label: 'Last of current Month',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_SUNDAY,
    label: 'Next occurrence of Sunday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_MONDAY,
    label: 'Next occurrence of Monday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_TUESDAY,
    label: 'Next occurrence of Tuesday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_WEDNESDAY,
    label: 'Next occurrence of Wednesday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_THURSDAY,
    label: 'Next occurrence of Thursday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_FRIDAY,
    label: 'Next occurrence of Friday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_SATURDAY,
    label: 'Next occurrence of Saturday',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_1ST_DAY_OF_MONTH,
    label: 'Next occurrence of 1st Day of Month',
  },
  {
    value: StartDateCalculation.NEXT_OCCURRENCE_OF_15th_DAY_OF_MONTH,
    label: 'Next occurrence of 15th Day of Month',
  },
];
export const mailchimpListSegments: TOption[] = [
  {
    value: 'select2-_mailchimp_segments-0-result-aeca-2413d390e5-3507686',
    label: 'Affilliates/Affiliates',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-3cww-2413d390e5-3507690',
    label: 'Affilliates/Ninja Users Update',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-ldtp-2413d390e5-3507694',
    label: 'Affilliates/EUREX',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-66of-2413d390e5-3507698',
    label: 'Affilliates/Ninja 7 Users Update Platform',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-v378-2413d390e5-3507714',
    label: 'Affilliates/November and December 2021. Affiliate Audience',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-udct-2413d390e5-3507720',
    label: 'Affilliates/January 2022 affiliates',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-95xz-2413d390e5-3507740',
    label: 'Affilliates/Aussie',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-u1yq-2413d390e5-3509287',
    label: 'Affilliates/Staff',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-8c64-32b8f3e837-3507804',
    label: 'Ultimate Outreach Campaign/Chris Loyal Traders',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-vezw-32b8f3e837-3507816',
    label: 'Ultimate Outreach Campaign/Loyal traders',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-7hts-32b8f3e837-3507820',
    label: 'Ultimate Outreach Campaign/Affiliates',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-60fo-32b8f3e837-3507824',
    label: 'Ultimate Outreach Campaign/Ninja Users Update',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-tovh-32b8f3e837-3507828',
    label: 'Ultimate Outreach Campaign/EUREX',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-oyu7-5cb79ff3c1-3510262',
    label: 'Competitions/May23 Competition',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-b75i-5cb79ff3c1-3510263',
    label: 'Competitions/Jan24 Competition',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-zpi6-5cb79ff3c1-3511307',
    label: 'Competitions/March 2025 Competition',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-ia0n-5cb79ff3c1-3511326',
    label: 'Competitions/Start March Competition 2025',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-afa6-5cb79ff3c1-3511337',
    label: 'Competitions/New User March',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-l97g-af4eda8589-2909757',
    label: 'Leeloo Trading/Affiliates',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-yy2c-af4eda8589-3337837',
    label: 'Leeloo Trading/EUREX',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-vwwq-af4eda8589-3507666',
    label: 'Leeloo Trading/Ninja Users Update',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-tp7p-af4eda8589-3507674',
    label: 'Leeloo Trading/Ninja 7 Users Update Platform',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-5ukl-af4eda8589-3507678',
    label: 'Leeloo Trading/May 31, 2021 Unsubscribed users',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-bgcu-af4eda8589-3507682',
    label: 'Leeloo Trading/August Unsubscribers',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-6bdv-af4eda8589-3507706',
    label: 'Leeloo Trading/November and December 2021',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-kzch-af4eda8589-3507716',
    label: 'Leeloo Trading/January 2022',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-jt7f-af4eda8589-3507724',
    label: 'Leeloo Trading/February 2022 unsubscribes',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-we67-af4eda8589-3507728',
    label: 'Leeloo Trading/DC Meats USA and Canada',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-3mfr-af4eda8589-3507732',
    label: `Leeloo Trading/May's unsubscribes 2022`,
  },
  {
    value: 'select2-_mailchimp_segments-0-result-ipvb-af4eda8589-3507736',
    label: `Leeloo Trading/May's cleaned subscribes`,
  },
  {
    value: 'select2-_mailchimp_segments-0-result-opvs-af4eda8589-3507772',
    label: 'Leeloo Trading/July 4th 2022 Contest Competition',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-5jkw-af4eda8589-3507788',
    label: 'Leeloo Trading/September Unsubscribes 2022',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-rys1-af4eda8589-3507792',
    label: 'Leeloo Trading/December, 2022',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-6z95-af4eda8589-3507796',
    label: 'Leeloo Trading/Cleaned users Dec, 2022',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-22kz-af4eda8589-3507800',
    label: 'Leeloo Trading/Loyal traders',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-ato8-af4eda8589-3507812',
    label: 'Leeloo Trading/Disengaged subscribers',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-imvc-af4eda8589-3507836',
    label: `Leeloo Trading/July's Unsubscribes 2023`,
  },
  {
    value: 'select2-_mailchimp_segments-0-result-iwa3-af4eda8589-3510348',
    label: 'Leeloo Trading/amember July 2024 to Jan 05 2025 import',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-qhid-af4eda8589-3510416',
    label: 'Leeloo Trading/Black Friday 2024',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-veq1-af4eda8589-3510440',
    label: 'Leeloo Trading/Amember importat Jan 2024 to Jan 10 2025',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-87q6-af4eda8589-3512251',
    label: 'Leeloo Trading/New May 2025',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-1638-ea0edd4c58-3507839',
    label: 'Elite Traders/Free CM 05/12 Group',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-je2d-ea0edd4c58-3508952',
    label: 'Elite Traders/Staff',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-driy-ea0edd4c58-3509518',
    label: 'Elite Traders/Black Friday',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-qlk2-ea0edd4c58-3510759',
    label: 'Elite Traders/Unbounce',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-zsh2-ea0edd4c58-3510760',
    label: 'Elite Traders/Elite Trader Onboarded',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-6omd-ea0edd4c58-3510761',
    label: 'Elite Traders/Elite Trader Survey Completed',
  },
  {
    value: 'select2-_mailchimp_segments-0-result-340u-ea0edd4c58-3510784',
    label: 'Elite Traders/Elite Added Jan 28 2025',
  },
];

export const currencyData: TOption[] = [
  { value: 'aed', label: 'AED' },
  { value: 'afn', label: 'AFN' },
  { value: 'all', label: 'ALL' },
  { value: 'amd', label: 'AMD' },
  { value: 'ang', label: 'ANG' },
  { value: 'aoa', label: 'AOA' },
  { value: 'ars', label: 'ARS' },
  { value: 'aud', label: 'AUD' },
  { value: 'awg', label: 'AWG' },
  { value: 'azn', label: 'AZN' },
  { value: 'bam', label: 'BAM' },
  { value: 'bbd', label: 'BBD' },
  { value: 'bdt', label: 'BDT' },
  { value: 'bgn', label: 'BGN' },
  { value: 'bhd', label: 'BHD' },
  { value: 'bif', label: 'BIF' },
  { value: 'bmd', label: 'BMD' },
  { value: 'bnd', label: 'BND' },
  { value: 'bob', label: 'BOB' },
  { value: 'bov', label: 'BOV' },
  { value: 'brl', label: 'BRL' },
  { value: 'bsd', label: 'BSD' },
  { value: 'btn', label: 'BTN' },
  { value: 'bwp', label: 'BWP' },
  { value: 'byr', label: 'BYR' },
  { value: 'bzd', label: 'BZD' },
  { value: 'cad', label: 'CAD' },
  { value: 'cdf', label: 'CDF' },
  { value: 'che', label: 'CHE' },
  { value: 'chf', label: 'CHF' },
  { value: 'chw', label: 'CHW' },
  { value: 'clf', label: 'CLF' },
  { value: 'clp', label: 'CLP' },
  { value: 'cny', label: 'CNY' },
  { value: 'cop', label: 'COP' },
  { value: 'cou', label: 'COU' },
  { value: 'crc', label: 'CRC' },
  { value: 'cuc', label: 'CUC' },
  { value: 'cup', label: 'CUP' },
  { value: 'cve', label: 'CVE' },
  { value: 'czk', label: 'CZK' },
  { value: 'djf', label: 'DJF' },
  { value: 'dkk', label: 'DKK' },
  { value: 'dop', label: 'DOP' },
  { value: 'dzd', label: 'DZD' },
  { value: 'egp', label: 'EGP' },
  { value: 'ern', label: 'ERN' },
  { value: 'etb', label: 'ETB' },
  { value: 'eur', label: 'EUR' },
  { value: 'fjd', label: 'FJD' },
  { value: 'fkp', label: 'FKP' },
  { value: 'gbp', label: 'GBP' },
  { value: 'gel', label: 'GEL' },
  { value: 'ghs', label: 'GHS' },
  { value: 'gip', label: 'GIP' },
  { value: 'gmd', label: 'GMD' },
  { value: 'gnf', label: 'GNF' },
  { value: 'gtq', label: 'GTQ' },
  { value: 'gyd', label: 'GYD' },
  { value: 'hkd', label: 'HKD' },
  { value: 'hnl', label: 'HNL' },
  { value: 'hrk', label: 'HRK' },
  { value: 'htg', label: 'HTG' },
  { value: 'huf', label: 'HUF' },
  { value: 'idr', label: 'IDR' },
  { value: 'ils', label: 'ILS' },
  { value: 'inr', label: 'INR' },
  { value: 'iqd', label: 'IQD' },
  { value: 'irr', label: 'IRR' },
  { value: 'isk', label: 'ISK' },
  { value: 'jmd', label: 'JMD' },
  { value: 'jod', label: 'JOD' },
  { value: 'jpy', label: 'JPY' },
  { value: 'kes', label: 'KES' },
  { value: 'kgs', label: 'KGS' },
  { value: 'khr', label: 'KHR' },
  { value: 'kmf', label: 'KMF' },
  { value: 'kpw', label: 'KPW' },
  { value: 'krw', label: 'KRW' },
  { value: 'kwd', label: 'KWD' },
  { value: 'kyd', label: 'KYD' },
  { value: 'kzt', label: 'KZT' },
  { value: 'lak', label: 'LAK' },
  { value: 'lbp', label: 'LBP' },
  { value: 'lkr', label: 'LKR' },
  { value: 'lrd', label: 'LRD' },
  { value: 'lsl', label: 'LSL' },
  { value: 'ltl', label: 'LTL' },
  { value: 'lvl', label: 'LVL' },
  { value: 'lyd', label: 'LYD' },
  { value: 'mad', label: 'MAD' },
  { value: 'mdl', label: 'MDL' },
  { value: 'mga', label: 'MGA' },
  { value: 'mkd', label: 'MKD' },
  { value: 'mmk', label: 'MMK' },
  { value: 'mnt', label: 'MNT' },
  { value: 'mop', label: 'MOP' },
  { value: 'mro', label: 'MRO' },
  { value: 'mur', label: 'MUR' },
  { value: 'mvr', label: 'MVR' },
  { value: 'mwk', label: 'MWK' },
  { value: 'mxn', label: 'MXN' },
  { value: 'mxv', label: 'MXV' },
  { value: 'myr', label: 'MYR' },
  { value: 'mzn', label: 'MZN' },
  { value: 'nad', label: 'NAD' },
  { value: 'ngn', label: 'NGN' },
  { value: 'nio', label: 'NIO' },
  { value: 'nok', label: 'NOK' },
  { value: 'npr', label: 'NPR' },
  { value: 'nzd', label: 'NZD' },
  { value: 'omr', label: 'OMR' },
  { value: 'pab', label: 'PAB' },
  { value: 'pen', label: 'PEN' },
  { value: 'pgk', label: 'PGK' },
  { value: 'php', label: 'PHP' },
  { value: 'pkr', label: 'PKR' },
  { value: 'pln', label: 'PLN' },
  { value: 'pyg', label: 'PYG' },
  { value: 'qar', label: 'QAR' },
  { value: 'ron', label: 'RON' },
  { value: 'rsd', label: 'RSD' },
  { value: 'rub', label: 'RUB' },
  { value: 'rwf', label: 'RWF' },
  { value: 'sar', label: 'SAR' },
  { value: 'sbd', label: 'SBD' },
  { value: 'scr', label: 'SCR' },
  { value: 'sdg', label: 'SDG' },
  { value: 'sek', label: 'SEK' },
  { value: 'sgd', label: 'SGD' },
  { value: 'shp', label: 'SHP' },
  { value: 'sll', label: 'SLL' },
  { value: 'sos', label: 'SOS' },
  { value: 'srd', label: 'SRD' },
  { value: 'ssp', label: 'SSP' },
  { value: 'std', label: 'STD' },
  { value: 'svc', label: 'SVC' },
  { value: 'syp', label: 'SYP' },
  { value: 'szl', label: 'SZL' },
  { value: 'thb', label: 'THB' },
  { value: 'tjs', label: 'TJS' },
  { value: 'tmt', label: 'TMT' },
  { value: 'tnd', label: 'TND' },
  { value: 'top', label: 'TOP' },
  { value: 'try', label: 'TRY' },
  { value: 'ttd', label: 'TTD' },
  { value: 'twd', label: 'TWD' },
  { value: 'tzs', label: 'TZS' },
  { value: 'uah', label: 'UAH' },
  { value: 'ugx', label: 'UGX' },
  { value: 'usd', label: 'USD' },
  { value: 'uyi', label: 'UYI' },
  { value: 'uyu', label: 'UYU' },
  { value: 'uzs', label: 'UZS' },
  { value: 'vef', label: 'VEF' },
  { value: 'vnd', label: 'VND' },
  { value: 'vuv', label: 'VUV' },
  { value: 'wst', label: 'WST' },
  { value: 'xaf', label: 'XAF' },
  { value: 'xcd', label: 'XCD' },
  { value: 'xof', label: 'XOF' },
  { value: 'xpf', label: 'XPF' },
  { value: 'yer', label: 'YER' },
  { value: 'zar', label: 'ZAR' },
  { value: 'zmk', label: 'ZMK' },
  { value: 'zwl', label: 'ZWL' },
];
